import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import moment from 'moment';
import translationEN from 'src/locales/en/translation.json';
import translationFR from 'src/locales/fr/translation.json';
import translationJP from 'src/locales/jp/translation.json';

const DETECTION_OPTIONS = {
    order: ['navigator'],
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            format: (value, format, lng) => {
                if (value instanceof Date) {
                    return moment(value).format(format);
                }
                if (format === 'currency') {
                    if (lng === 'en-US') return `$${value}`;
                    if (lng === 'fr-FR')
                        return `€${value.split('.').join(',')}`;
                }
                return value;
            },
        },
        detection: DETECTION_OPTIONS,
        resources: {
            en: {
                translation: translationEN,
            },
            fr: {
                translation: translationFR,
            },
            ja: {
                translation: translationJP,
            },
        },
    });

export default i18n;
